import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class InfoService {

  private infoSubject = new Subject<any>();

  constructor() { }

  setInfo(data: any): void {
    this.infoSubject.next(data);
  }

  getInfos(): Observable<any> {
    return this.infoSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/info.service.ts